import axios from "axios";

export const API_BASE =
  "https://tarpex.live/api" ||
  "https://trampuline-backend.vercel.app/api" ||
  // process.env.REACT_APP_API_URL ||
  "http://localhost:5050/api";

const client = axios.create({
  baseURL: API_BASE,
  timeout: 45000,
  headers: { "Content-Type": "application/json" },
});

export const TOKEN_KEY = "tarpex_admin_token";

client.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Unwraps the API envelope so callers get `data` directly, and normalises
 * every failure into an Error carrying the server's message.
 */
client.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // An expired/invalid session must not leave the panel in a half-logged-in state.
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith("/login")) {
        window.location.replace("/login");
      }
    }

    const message =
      (error.response && error.response.data && error.response.data.message) ||
      (error.code === "ECONNABORTED"
        ? "The server took too long to respond"
        : error.message === "Network Error"
        ? "Cannot reach the API server. Is it running on port 5000?"
        : "Something went wrong");

    const err = new Error(message);
    err.status = error.response ? error.response.status : 0;
    err.errors =
      error.response && error.response.data ? error.response.data.errors : null;
    return Promise.reject(err);
  }
);

/** Multipart helper — lets axios set its own boundary. */
export const upload = (url, formData) =>
  client.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export default client;
